<main id="main-content" tabindex="-1">
  <div class="my-4 content-contain">
    <prism-title additionalClasses="text-4xl" title="Facilitation Guides"></prism-title>
    <ul  class="list-disc ml-10 mb-5">
      <li>
        A max of 6 separate files can be uploaded.
      </li>
      <li>
        The maximum size for each file is 500MB.
      </li>
      <li>
        Click the down arrow next to the facilitation guide you want to view/download.
      </li>
    </ul>


    @if (isSuperAdmin) {
    <prism-btn [disabled]="hasMaxAttachments" btnClass="md:my-1 bg-white text-dark-purple font-bold border-2 p-0 m-0 rounded-xl border-dark-purple"
      (click)="toggleAddAttachment()">
      <i class="uil uil-plus text-dark-purple font-bold pr-1"></i>
      Add Attachment
    </prism-btn>
    }

    @if (addAttachment) {
    <prism-facilitation-attachment [guideId]="guide?.id || guideForm?.get('id')?.value" [isEdit]="isEdit"
      (closeAttachment)="toggleAddAttachment()"
      (updateAttachments)="updateAttachments()"></prism-facilitation-attachment>
    }

    <div class="flex flex-col gap-3 mt-5">
      @if ((attachments?.length ?? 0) > 0) {
      @for (attachment of attachments; track $index) {
      <div class="flex items-center gap-2">
        <a class="group flex gap-2 bg-light-purple w-[400px] p-2 rounded-lg justify-between items-center"
          [href]="attachment.blobUrlSas" [attr.download]="attachment.fileName" target="_blank" rel="noopener">
          <div class="relative overflow-hidden w-[320px]">
            <p class="marquee text-base font-semibold whitespace-nowrap">
              {{ attachment.fileName }}
            </p>
          </div>
          <i class="uil uil-import text-xl text-dark-purple"></i>
        </a>

        @if (isSuperAdmin) {
          <prism-btn type="button"
            btnClass="bg-white text-dark-purple font-bold border-2 rounded-xl border-dark-purple px-3 py-1"
            (click)="deleteAttachment(attachment.id)" aria-label="Delete attachment {{ attachment.fileName }}">
            <i class="uil uil-trash-alt text-lg"></i>
            <span class="text-sm pl-1">Delete</span>
          </prism-btn>
        }
      </div>
      }
      } @else {
      <p class="font-bold italic">No attachments available</p>
      }
    </div>

  </div>
</main>